<div class="grid" *ngIf="entityFilterTiles">
  <div *ngFor="let tile of entityFilterTiles; let tileIndex = index" class="col-12 md:col-2 lg:col-2">
    <p-card
      (click)="disabledTiles[tileIndex] || !initialLoadCompleted[tileIndex] ? '' : toggleCheck(tileIndex)"
      [class]="{
        'entity-tile__card': true,
        'entity-tile__card--selected': isChecked[tileIndex],
        'entity-tile__card--disabled': disabledTiles[tileIndex]
      }"
      [(ngModel)]="isChecked[tileIndex]"
      ngDefaultControl
      [attr.data-cy]="'entityTile_' + tile?.id"
    >
      <div id="tileWrapper-{{ tileIndex }}" class="h-full p-2 flex align-content-start" style="flex-flow: row wrap">
        <div class="w-full text-center" style="word-wrap: break-word">
          <span class="text-2xl font-bold" [attr.data-cy]="'entityTile_' + tile?.id + '_header'">{{
            tile.header ? tile.header : 'Header'
          }}</span>
        </div>
        <div class="w-full text-center" style="word-wrap: break-word">
          <small
            [style]="{ color: disabledTiles[tileIndex] || isChecked[tileIndex] ? 'black' : 'darkgray' }"
            [attr.data-cy]="'entityTile_' + tile?.id + '_description'"
            >{{ tile.description }}</small
          >
        </div>
        <div *ngIf="initialLoadCompleted[tileIndex]" class="w-full h-2rem text-center">
          <span class="text-2xl font-bold" [attr.data-cy]="'entityTile_' + tile?.id + '_count'">{{
            tile.count ? tile.count : '0'
          }}</span>
        </div>
        <div *ngIf="!initialLoadCompleted[tileIndex]" class="w-full h-2rem text-center flex">
          <div class="relative m-auto w-2rem h-2rem p-skeleton"></div>
        </div>
      </div>
    </p-card>
  </div>
</div>
